import React, { useState, useEffect } from 'react'
import 'animate.css'
import { Row, Col } from 'antd'

import CardInfo from 'components/CardInfo'
import ScrollUpBtn from 'components/ScrollUpBtn'

import { httpClient } from 'core/util/httpClient'
import { course } from 'core/schemas'

import requestEmail from 'assets/images/png/Pic-01.png'
import requestLearning from 'assets/images/png/Pic-02.png'
import library from 'assets/images/png/Pic-03.png'
import sports from 'assets/images/png/Pic-04.png'
import medical from 'assets/images/png/Pic-05.png'
import scholarship from 'assets/images/png/Pic-06.png'
import dormitory from 'assets/images/png/Pic-07.png'

import { Container, Title, CardContainer, Href } from './courseInfo.style'

const CourseInfo = () => {
  const [dataCourse, setDataCourse] = useState([])

  useEffect(() => {
    window.scrollTo(0, 0)
    
    getDataCourse()
  }, [])

  const getDataCourse = async () => {
    const response = await httpClient.get(course)

    if (response?.data?.code === 200) {
      const data = response?.data?.data
      setDataCourse(data?.course)
    } else {
      setDataCourse([])
    }
  }

  const listImage = {
    'department-science': requestEmail,
    'department-social': requestLearning,
    'department-agricultural': library,
    'department-engineering': sports,
    'department-medicine': medical,
    'department-nursing': scholarship,
    'department-dentistry': dormitory,
    'department-public-health': requestEmail,
    'department-degitech': library,
  }

  return (
    <>
      <Container>
        <Row>
          <Col span={24}>
            <Title className='animate__animated animate__flipInX animate__slow'>
              แนะนำหลักสูตร
            </Title>
          </Col>
        </Row>

        <CardContainer>
          {dataCourse.length >= 0 &&
            dataCourse.map((item, index) => {
              return (
                <Href to={item?.slang} key={index}>
                  <CardInfo
                    src={item?.image ? item?.image : listImage[item?.slang]}
                    nameImage={item?.nameEN}
                    name={item?.nameTH}
                    cursor='true'
                  />
                </Href>
              )
            })}
        </CardContainer>
      </Container>
      <ScrollUpBtn />
    </>
  )
}

export default CourseInfo
